import React, { useEffect, useRef } from "react";
import { Grid, InputLabel, Tooltip, Button, Select } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { compose, lifecycle } from "recompose";
import { connect, useDispatch } from "react-redux";
import {
  ShowAttributeList,
  ResetFilterDate,
  SelectUserFilter,
  SetUserFilter,
  SetSelectedAddress,
  SelectDateSurveyed,
  SetRankFilter,
} from "../../../services/actions/RoadAction";
import { withTranslation, Trans } from "react-i18next";
import { GetUsers } from "../../../services/actions/UserAction";
import FilterCardOld from "./FilterCard_Old";
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { MAPBOX_ACCESSTOKEN } from "../../../shared/utils/constant";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { isNull, Toast } from "../../../shared/utils/objectExtensions";
import { Clear as ClearIcon, Add as AddIcon } from "@material-ui/icons";
import { SetSurfaceFilter } from "../../../services/actions/SurfaceAction";
import { resetDataType } from "../../../services/actions/GisAction";

/**
 * フィルタコンポーネント
 * @param {*} param0
 * @returns
 */
const FilterCard = ({
  selectedDates,
  SetSelectedDate,
  datesHaveData,
  isAdmin,
  userFilter,
  SetUserId,
  users,
  loggedUser,
  mapEl,
  closeSurveyedDetail,
  mapLoaded,
  ResetFilter,
  getUsers,
}) => {
  const dispatch = useDispatch();

  const currentUser =
    users?.find((x) => x.id == userFilter) ||
    JSON.parse(sessionStorage.getItem("userLogged"));
  const isOldUser = currentUser?.isOldUser ? true : false;

  const date_ = useRef(null);
  const index_ = useRef(null);

  return isOldUser ? (
    <FilterCardOld />
  ) : (
    <div className="filter-card">
      <Grid container spacing={3}>
        <Grid item md={12} style={{ width: "100%" }}>
          {isAdmin && users && users.length > 0 && (
            <div style={{ marginBottom: "10px" }}>
              <InputLabel
                htmlFor="user"
                style={{ color: "white", paddingBottom: "5px" }}
              >
                <Trans>user</Trans>
              </InputLabel>
              <FormControl className="field" variant="outlined">
                <Select
                  native
                  name="user"
                  value={isNull(userFilter) ? "" : userFilter}
                  onChange={(e) => {
                    closeSurveyedDetail();
                    SetUserId(e.target.value);
                    // フィルタのリセット(date, Surface Condition, Surface Type, Actual/Predicted)
                    dispatch(SetSurfaceFilter([]));
                    dispatch(SetRankFilter([]));
                    dispatch(ResetFilterDate());
                    dispatch(resetDataType());
                  }}
                >
                  {loggedUser && (
                    <option key={loggedUser.id} value={loggedUser.id}>
                      {loggedUser.userName}
                    </option>
                  )}
                  {users.map((x) => (
                    <option key={x.id} value={x.id}>
                      {x.userName} - {x.firstName} {x.lastNameF}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}
          <GeocoderElement mapEl={mapEl} mapLoaded={mapLoaded} userFilter={userFilter} />

          {/* 日付フィルタ */}
          {/* <InputLabel
            htmlFor="date-filter"
            style={{ color: "white", paddingBottom: "5px", paddingTop: "5px" }}
          >
            <Trans>date</Trans>
          </InputLabel>
          {selectedDates.map((selectedDate, idx) => (
            <Grid key={idx} container>
              <Grid item xs={11}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    name="date-filter"
                    autoOk={true}
                    allowKeyboardControl={false}
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id={`date-picker-inline-${idx}`}
                    value={selectedDate}
                    views={["year", "month", "date"]}
                    onChange={(date) => {
                      if (date == "Invalid Date") {
                        Toast.fire({
                          type: "warning",
                          title: "Invalid Date",
                        });
                      } else {
                        index_.current = idx;
                        date_.current = date;
                      }
                    }}
                    onFocus={(e) => {
                      e.target.blur()
                    }}
                    onClose={() => {
                      SetSelectedDate(index_.current, date_.current);
                    }}
                    KeyboardButtonProps={{ "aria-label": "change date" }}
                    renderDay={(
                      day,
                      selectedDate,
                      dayInCurrentMonth,
                      dayComponent
                    ) => {
                      const dateHasData =
                        dayInCurrentMonth &&
                        datesHaveData &&
                        datesHaveData.includes(day.getDate());
                      const content = (
                        <div
                          readOnly
                          className={`${dateHasData ? "date-has-data" : ""} ${selectedDate.getDate() === day.getDate() &&
                            selectedDate.getMonth() === day.getMonth() ? "selected-date" : ""
                            }`}>
                          {dayComponent}
                        </div>
                      );
                      return dateHasData ? (
                        <Tooltip title={<Trans>has_data</Trans>}>
                          {content}
                        </Tooltip>
                      ) : (
                        content
                      );
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={1}>
                <Button
                  size="small"
                  className="delete-btn"
                  startIcon={<ClearIcon />}
                  onClick={() => SetSelectedDate(idx, null)}
                />
              </Grid>
            </Grid>
          ))}
          <Grid container>
            <Grid item xs={selectedDates.length > 0 ? 11 : 12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  autoOk={true}
                  allowKeyboardControl={false}
                  variant="inline"
                  inputVariant="outlined"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-inline-add"
                  value={null}
                  views={["year", "month", "date"]}
                  onChange={(date) => {
                    if (date == "Invalid Date") {
                      Toast.fire({
                        type: "warning",
                        title: "Invalid Date",
                      });
                    } else {
                      index_.current = selectedDates.length;
                      date_.current = date;
                    }
                  }}
                  onFocus={(e) => {
                    e.target.blur()
                  }}
                  onClose={() => {
                    SetSelectedDate(index_.current, date_.current);
                  }}
                  KeyboardButtonProps={{ "aria-label": "change date" }}
                  renderDay={(
                    day,
                    selectedDate,
                    dayInCurrentMonth,
                    dayComponent
                  ) => {
                    const dateHasData =
                      dayInCurrentMonth &&
                      datesHaveData &&
                      datesHaveData.includes(day.getDate());
                    const content = (
                      <div
                        readOnly
                        className={`${dateHasData ? "date-has-data" : ""} ${selectedDate.getDate() === day.getDate() &&
                          selectedDate.getMonth() === day.getMonth() ? "selected-date" : ""
                          }`}>
                        {dayComponent}
                      </div>
                    );
                    return dateHasData ? (
                      <Tooltip title={<Trans>has_data</Trans>}>
                        {content}
                      </Tooltip>
                    ) : (
                      content
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            {selectedDates.length > 0 && (
              <Grid item xs={1}>
                <Button
                  disabled
                  size="small"
                  className="delete-btn"
                  style={{ color: "white" }}
                  startIcon={<AddIcon />}
                />
              </Grid>
            )}
          </Grid>
          {selectedDates.length > 0 && (
            <div className="clear-dates" onClick={() => ResetFilter(userFilter)}>
              <Button size="small" startIcon={<ClearIcon />}>
                <Trans>clear_filter</Trans>
              </Button>
            </div>
          )} */}

        </Grid>
      </Grid>
    </div>
  );
};

// ジオコーディングUI（Mapbox）
const GeocoderElement = ({
  mapEl,
  mapLoaded,
  userFilter
}) => {
  useEffect(() => {
    if (!mapLoaded || !userFilter) return;

    const mapGeocoder = new MapboxGeocoder({
      accessToken: MAPBOX_ACCESSTOKEN,
      mapboxgl: mapboxgl,
      language: "en",
      marker: false,
      placeholder: "Address"
    });
    const geocoderEle = document.getElementById('mapbox-geocoder-parent');
    geocoderEle.appendChild(mapGeocoder.onAdd(mapEl.current));

    // マーカー設置（住所検索UIを分離しているため、こちらでイベント定義が必要）
    const marker = new mapboxgl.Marker();
    mapGeocoder.on('result', (event) => {
      const coordinates = event.result.geometry.coordinates;

      marker.setLngLat(coordinates)
        .addTo(mapEl.current.getMap());
    });
  }, [mapLoaded]);

  return <div id="mapbox-geocoder-parent" />
}

export default compose(
  withTranslation("translations"),
  connect(
    (state) => ({
      selectedDates: state.road.selectedDates,
      selectedAddress: state.road.selectedAddress,
      uploading: state.road.uploading,
      isAdmin: state.auth.isAdmin,
      loggedUser: state.auth.user,
      datesHaveData: state.road.datesHaveData,
      userFilter: state.road.userFilter,
      users: state.user.users,
      surveyedAllocated: state.road.surveyedAllocated,
      mapLoaded: state.gis.mapLoaded
    }),
    (dispatch) => ({
      SetUserId: (userId) => dispatch(SelectUserFilter(userId)),
      ResetUserFilter: () => dispatch(SetUserFilter(null)),
      SetAddress: (address) => dispatch(SetSelectedAddress(address)),
      ShowAttributeList: () => dispatch(ShowAttributeList()),
      ResetFilter: () => dispatch(ResetFilterDate()),
      getUsers: (userId) => dispatch(GetUsers(userId)),
      SetSelectedDate: (idx, date) => dispatch(SelectDateSurveyed(idx, date)),
    })
  ),
  lifecycle({
    componentDidMount() {
      if (this.props.isAdmin) {
        this.props.getUsers(this.props.userFilter);
      } else if (this.props.loggedUser) {
        this.props.SetUserId(this.props.loggedUser.id);
      }
    },
    componentWillUnmount() {
      //this.props.ResetUserFilter();
    },
  })
)(FilterCard);
